import React from 'react';

// Section navigation dots (hidden by the final template palette, but kept for
// parity: useScrewAnimation still toggles their active state).
const SectionDots: React.FC = () => (
  <div className="section-dots" aria-label="區塊導覽">
    <a href="#home" aria-label="首頁"> </a>
    <a href="#products" aria-label="產品介紹"> </a>
    <a href="#ordering" aria-label="特規訂購"> </a>
    <a href="#contact" aria-label="聯絡資訊"> </a>
  </div>
);

export default SectionDots;
